/*
 * 作者: Fultom
 * 创建时间: 2022-02-18 18:07:59
 * 最近修改时间: 2025-11-14 16:55:57
 * 功能:
 */
/**
 * Created by likai on 2020年5月25日
 * Desc: 活动页面路由聚集地
 */
const _import = require("./_import_" + process.env.NODE_ENV);
const afterSaleRouter = [
  //游学活动
  {
    path: "/studyTour",
    name: "studyTour",
    component: _import("activity/2020-5-25/index"),
    hidden: true,
    title: "游学活动",
    meta: { title: "游学活动" }
  },
  //限时换购
  {
    path: "/timeLimitSwap",
    name: "timeLimitSwap",
    component: _import("activity/2021-1-7/index"),
    hidden: true,
    title: "限时换购",
    meta: { title: "限时换购" }
  },
  //5月福利
  {
    path: "/mayActivity",
    name: "mayCbeActivity",
    component: _import("activity/2021-4-21/index"),
    hidden: true,
    title: "5月福利",
    meta: { title: "5月福利" }
  },
  //5月福利规则
  {
    path: "/mayActivity/rule",
    name: "mayActivityRule",
    component: _import("activity/2021-4-21/rule"),
    hidden: true,
    title: "5月福利规则",
    meta: { title: "5月福利规则" }
  },
  //品牌游学
  {
    path: "/anhuiStudyTour",
    name: "AnhuiStudyTour",
    component: _import("activity/anhuiTour/index"),
    hidden: true,
    title: "品牌游学",
    meta: { title: "品牌游学" }
  },
  //AI换购
  {
    path: "/AIorder",
    name: "AIorder",
    component: _import("activity/AIorder/index"),
    hidden: true,
    title: "AI智能分析仪订购",
    meta: { title: "AI智能分析仪订购" }
  },
  // 2023-03 订货会 活动排行
  {
    path: "/saleRank",
    name: "SaleRank",
    component: _import("activity/saleRankData/index"),
    hidden: true,
    title: "“拾”光如初 不负相遇",
    meta: { title: "“拾”光如初 不负相遇" }
  },
  {
    // 2024-03 订货会 入口
    path: "/activity/202403/entrance",
    name: "Entrance202404",
    component: _import("activity/2024-03-11/index"),
    hidden: true,
    title: "春日礼遇·蓄力绽放",
    meta: { title: "春日礼遇·蓄力绽放" }
  },
  {
    // 2024-03 订货会 订单列表
    path: "/activity/202403/orderList",
    name: "OrderList202404",
    component: _import("activity/2024-03-11/dataInfo/index"),
    hidden: true,
    title: "我的有效盒数",
    meta: { title: "我的有效盒数" }
  },
  {
    // 2024-03 订货会 订单商品
    path: "/activity/202403/goodsInfo",
    name: "goodsInfo202404",
    component: _import("activity/2024-03-11/dataGoodsInfo/index"),
    hidden: true,
    title: "商品明细",
    meta: { title: "商品明细" }
  },
  {
    path: "/activity/migration",
    name: "Migration",
    component: _import("activity/migration/index"),
    hidden: true,
    title: "“e账户”注册会员号管理协议",
    meta: { title: "“e账户”注册会员号管理协议" }
  },
  {
    path: "/activity/tempPage",
    name: "TempPage",
    component: _import("activity/tempPage/index"),
    hidden: true,
    title: "温馨提示",
    meta: { title: "温馨提示" }
  }
];
export default afterSaleRouter;



// WEBPACK FOOTER //
// ./src/router/activity.js